export default function TrustSection() {
  return (
    <section className="py-16 md:py-24 bg-foreground-900">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16 items-center">
          <div className="lg:w-2/5 relative">
            <div className="relative -ml-4 lg:-ml-12">
              <img
                src="https://readdy.ai/api/search-image?query=Professional%20person%20reviewing%20documents%20at%20modern%20minimalist%20workspace%2C%20warm%20cream%20and%20soft%20beige%20background%2C%20soft%20natural%20daylight%20from%20side%2C%20editorial%20portrait%20photography%2C%20neutral%20sand%20tones%2C%20clean%20professional%20aesthetic&width=700&height=900&seq=usfans-trust-portrait-t15&orientation=portrait"
                alt="Redakcja USFans Polska"
                className="w-full h-auto rounded-2xl shadow-2xl"
                loading="lazy"
              />
            </div>
          </div>

          <div className="lg:w-3/5">
            <div className="text-accent-300 text-6xl font-serif mb-4">&ldquo;</div>
            <blockquote className="text-background-50 text-lg md:text-xl lg:text-2xl leading-relaxed mb-8">
              Redakcja USFans Polska działa od 2026 roku, dostarczając rzetelnych informacji o arkuszach USFans. Nie przechowujemy danych użytkowników, nie wymagamy rejestracji i nie sprzedajemy informacji osobom trzecim. Każdy arkusz jest weryfikowany przez nasz zespół ekspertów przed publikacją.
            </blockquote>
            <div className="mb-8">
              <p className="text-background-50 font-heading text-base font-semibold">Redakcja USFans Polska</p>
              <p className="text-background-100/60 text-sm mt-1">Ostatnia aktualizacja: Czerwiec 2026</p>
            </div>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center px-6 py-3 text-sm font-semibold text-foreground-950 bg-accent-400 hover:bg-accent-300 rounded-full transition-colors whitespace-nowrap"
            >
              Przejdź do kaspreadsheet.com
              <span className="w-4 h-4 flex items-center justify-center ml-2">
                <i className="ri-arrow-right-line"></i>
              </span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}